import { type IdeaRow } from './IdeaCard.types';
import { StandardIdeaCard } from './cards/StandardIdeaCard';
import { FunnelIdeaCard } from './cards/FunnelIdeaCard';
import { MilestoneIdeaCard } from './cards/MilestoneIdeaCard';

export type { IdeaRow } from './IdeaCard.types';

interface IdeaCardProps {
  readonly idea: IdeaRow;
  readonly isOwnProfile: boolean;
}

export const IdeaCard = ({ idea, isOwnProfile }: IdeaCardProps) => {
  const challenge = idea.challenge;

  if (challenge?.isMilestone) {
    return <MilestoneIdeaCard idea={idea} isOwnProfile={isOwnProfile} />;
  }

  if (challenge?.isFunnel) {
    return <FunnelIdeaCard idea={idea} isOwnProfile={isOwnProfile} />;
  }

  return <StandardIdeaCard idea={idea} isOwnProfile={isOwnProfile} />;
};
